module.exports = __webpack_public_path__ + "static/media/create.a7032412.svg";